import React, { useEffect, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useSelector } from 'react-redux';
import IndexedDBService, { storeName } from '../../Utils/DBConfig';


const TinyTextEditior = ({ getEditorContent, kirtanId, importData, getEditorHtml }) => {

    const [kirtanData, setKirtanData] = useState({});

    const [editorData, setEditorData] = useState("");

    const localTinyMCEScriptSrc = `${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`;

    const isDbInitialized = useSelector((state) => state.db.isDbInitialized);

    useEffect(() => {
        isDbInitialized &&
            IndexedDBService.getAllData(storeName).then((data) =>
                setKirtanData(Object.values(data).find((kirtan) => kirtan.id === Number(kirtanId)))
            );
    }, [isDbInitialized, kirtanId]);

    useEffect(() => {
        if (kirtanData && Object.keys(kirtanData).length > 0) {
            setEditorData((kirtanData.originalContent));
            getEditorContent(kirtanData.originalContent);
        }
    }, [kirtanData]);

    const handleEditorChange = (content, editor) => {
        getEditorHtml(editor.getContent({ format: 'html' }));
        getEditorContent(content);
    };

    useEffect(() => {
        if (importData?.length > 5) {
            setEditorData(importData);
        }
    }, [importData]);

    return (
        <>
            <Editor
                tinymceScriptSrc={localTinyMCEScriptSrc}
                init={{
                    license_key: 'n90tw3sxlkuzpsip6nv3d8b5e5v5qywageetd241hh7eab1w',
                    menubar: false,
                    toolbar: [
                        { name: 'history', items: ['undo', 'redo'] },
                        { name: 'fontFamily', items: ['fontFamily'] },
                        { name: 'formatting', items: ['bold', 'italic', 'underline'] },
                        { name: 'forecolor', items: ['forecolor'] },
                    ],
                    font_family_formats: `
                    ગુજ-ગોપિકા-ટૂ-બોલ્ડ=Guj_Gopika_Two_Bold;
                    હિન-સીસી-દેવનાગરી-બોલ્ડ-સુલેખ=Hin_CC-Devnagri_Bold_SULEKH;
                    સંસ્કૃત-જોડાક્ષર-બી-સુલેખ=AA_Sanskrut_Jodaxar_B_SULEKH;
                    Ghanu_unicode_Guj=Ghanu_unicode_Guj;
                    Gyan_Uni_Bold_Hindi=Gyan_Uni_Bold_Hindi;
                    સંસ્કૃત ટેક્સ્ટ-બોલ્ડ=UH002 SanskritText-Regular;
                    સંસ્કૃત ટેક્સ્ટ-સામાન્ય=UH002 SanskritText-Bold;`,
                    tinycomments_mode: 'embedded',
                    tinycomments_author: 'Author name',
                    mergetags_list: [
                        { value: 'First.Name', title: 'First Name' },
                        { value: 'Email', title: 'Email' },
                    ],
                    ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                    height: '650px',
                    content_style: `
                    @font-face {
                        font-family: 'Ghanu_unicode_Guj';
                        src: url("./fonts/Ghanu.ttc") format('truetype');
                    }
                    
                    @font-face {
                        font-family: 'Guj_Gopika_Two_Bold';
                        src: url("./fonts/Guj_Gopika_Two_Bold.ttf") format('truetype');
                    }
                    
                    @font-face {
                        font-family: 'Gyan_Uni_Bold_Hindi';
                        src: url("./fonts/Gyan_Uni_Bold.ttf") format('truetype');
                    }
                    
                    @font-face {
                        font-family: 'Hin_CC-Devnagri_Bold_SULEKH';
                        src: url("./fonts/H-devb_1.ttf") format('truetype');
                    }
                    
                    @font-face {
                        font-family: 'AA_Sanskrut_Jodaxar_B_SULEKH';
                        src: url("./fonts/SanjodaB.ttf") format('truetype');
                    }

                    @font-face {
                        font-family: 'UH002 SanskritText-Bold';
                        src: url("./fonts/UH002 SanskritText-Bold.ttf") format('truetype');
                    }

                    @font-face {
                        font-family: 'UH002 SanskritText-Regular';
                        src: url("./fonts/UH002 SanskritText-Regular.ttf") format('truetype');
                    }

                    body {
                        font-family: monospace;
                        font-size: 23px;
                    }`
                }}
                initialValue={editorData}
                onEditorChange={handleEditorChange}
            />
        </>
    );
};
export default TinyTextEditior;